import { css as x, LitElement as y, html as n, nothing as h } from "lit";
import { query as w, property as s, state as v, customElement as k } from "lit/decorators.js";
import { classMap as g } from "lit/directives/class-map.js";
import { b as $, f as O } from "./styles-scZ6dVz-.js";
import { b as c, a as u } from "./events-CkEPl0SM.js";
import { g as b } from "./a11y-DxQW21Jt.js";
var C = Object.defineProperty, I = Object.getOwnPropertyDescriptor, i = (e, r, o, d) => {
  for (var l = d > 1 ? void 0 : d ? I(r, o) : r, p = e.length - 1, a; p >= 0; p--)
    (a = e[p]) && (l = (d ? a(r, o, l) : a(l)) || l);
  return d && l && C(r, o, l), l;
};
let t = class extends y {
  constructor() {
    super(...arguments), this.inputId = b("ark-autocomplete"), this.listboxId = b("ark-listbox"), this.value = "", this.options = [], this.size = "md", this.disabled = !1, this.required = !1, this.invalid = !1, this.clearable = !1, this.loading = !1, this.noResultsText = "No results found", this.filterOptions = !0, this.isOpen = !1, this.inputValue = "", this.highlightedIndex = -1, this.hasFocus = !1, this.handleDocumentClick = (e) => {
      e.composedPath().includes(this) || (this.isOpen = !1);
    };
  }
  get filteredOptions() {
    if (!this.filterOptions || !this.inputValue)
      return this.options;
    const e = this.inputValue.toLowerCase();
    return this.options.filter(
      (r) => r.label.toLowerCase().includes(e)
    );
  }
  get selectedOption() {
    return this.options.find((e) => e.value === this.value);
  }
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this.handleDocumentClick);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("click", this.handleDocumentClick);
  }
  updated(e) {
    if (e.has("value")) {
      const r = this.selectedOption;
      r ? this.inputValue = r.label : this.value || (this.inputValue = "");
    }
  }
  /** Focus the input */
  focus(e) {
    this.inputElement?.focus(e);
  }
  /** Blur the input */
  blur() {
    this.inputElement?.blur();
  }
  /** Clear the selection */
  clear() {
    this.value = "", this.inputValue = "", c(this, u.CLEAR), c(this, u.CHANGE, { value: "" });
  }
  handleInputClick() {
    this.disabled || (this.isOpen = !0);
  }
  handleInput(e) {
    const r = e.target;
    this.inputValue = r.value, this.isOpen = !0, this.highlightedIndex = 0, c(this, u.INPUT, { value: this.inputValue });
  }
  handleFocus() {
    this.hasFocus = !0, c(this, u.FOCUS);
  }
  handleBlur() {
    this.hasFocus = !1, c(this, u.BLUR);
  }
  handleKeydown(e) {
    const r = this.filteredOptions;
    switch (e.key) {
      case "ArrowDown":
        e.preventDefault(), this.isOpen ? this.highlightedIndex = Math.min(
          this.highlightedIndex + 1,
          r.length - 1
        ) : this.isOpen = !0;
        break;
      case "ArrowUp":
        e.preventDefault(), this.isOpen && (this.highlightedIndex = Math.max(this.highlightedIndex - 1, 0));
        break;
      case "Enter":
        if (e.preventDefault(), this.isOpen && this.highlightedIndex >= 0) {
          const o = r[this.highlightedIndex];
          o && !o.disabled && this.selectOption(o);
        }
        break;
      case "Escape":
        e.preventDefault(), this.isOpen = !1;
        break;
      case "Tab":
        this.isOpen = !1;
        break;
    }
  }
  selectOption(e) {
    this.value = e.value, this.inputValue = e.label, this.isOpen = !1, c(this, u.CHANGE, { value: e.value, option: e });
  }
  handleOptionClick(e) {
    e.disabled || this.selectOption(e);
  }
  handleClearClick(e) {
    e.stopPropagation(), this.clear(), this.inputElement?.focus();
  }
  render() {
    const e = {
      wrapper: !0,
      [this.size]: !0,
      disabled: this.disabled,
      invalid: this.invalid,
      focused: this.hasFocus
    }, r = {
      listbox: !0,
      open: this.isOpen && !this.disabled
    }, o = n`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m6 9 6 6 6-6"/>
      </svg>
    `, d = n`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
      </svg>
    `, l = n`
      <svg class="option-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20 6 9 17l-5-5"/>
      </svg>
    `, p = this.filteredOptions;
    return n`
      <div part="wrapper" class=${g(e)}>
        <span part="prefix" class="prefix">
          <slot name="prefix"></slot>
        </span>

        <input
          part="input"
          id=${this.inputId}
          type="text"
          role="combobox"
          aria-autocomplete="list"
          aria-expanded=${this.isOpen}
          aria-controls=${this.listboxId}
          aria-activedescendant=${this.highlightedIndex >= 0 ? `${this.listboxId}-option-${this.highlightedIndex}` : h}
          placeholder=${this.placeholder ?? h}
          name=${this.name ?? h}
          .value=${this.inputValue}
          ?disabled=${this.disabled}
          ?required=${this.required}
          aria-invalid=${this.invalid ? "true" : h}
          @click=${this.handleInputClick}
          @input=${this.handleInput}
          @focus=${this.handleFocus}
          @blur=${this.handleBlur}
          @keydown=${this.handleKeydown}
        />

        ${this.clearable && this.value ? n`
              <button
                part="clear"
                type="button"
                class="clear-btn"
                aria-label="Clear selection"
                @click=${this.handleClearClick}
              >
                ${d}
              </button>
            ` : h}

        <span part="suffix" class="suffix">
          <slot name="suffix"></slot>
        </span>

        <span class="icon ${this.isOpen ? "open" : ""}">
          ${o}
        </span>
      </div>

      <div
        part="listbox"
        id=${this.listboxId}
        class=${g(r)}
        role="listbox"
        aria-label="Options"
      >
        ${this.loading ? n`
              <div class="loading">
                <ark-spinner size="sm"></ark-spinner>
              </div>
            ` : p.length === 0 ? n`<div class="no-results">${this.noResultsText}</div>` : p.map((a, f) => {
      const m = {
        option: !0,
        highlighted: f === this.highlightedIndex,
        selected: a.value === this.value,
        disabled: a.disabled ?? !1
      };
      return n`
                <div
                  part="option"
                  id="${this.listboxId}-option-${f}"
                  class=${g(m)}
                  role="option"
                  aria-selected=${a.value === this.value}
                  aria-disabled=${a.disabled ?? !1}
                  @click=${() => this.handleOptionClick(a)}
                  @mouseenter=${() => this.highlightedIndex = f}
                >
                  <span class="option-label">${a.label}</span>
                  ${a.value === this.value ? l : h}
                </div>
              `;
    })}
      </div>
    `;
  }
};
t.styles = [
  $,
  O,
  x`
      :host {
        display: block;
        position: relative;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .wrapper {
        position: relative;
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
        background-color: var(--r5-bg);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-md);
        transition-property: border-color, box-shadow;
        transition-duration: var(--r5-duration-fast);
        transition-timing-function: var(--r5-ease-default);
      }

      .wrapper:focus-within {
        border-color: var(--r5-border-focus);
        box-shadow: 0 0 0 var(--r5-focus-ring-width) var(--r5-color-primary-100);
      }

      .wrapper.invalid {
        border-color: var(--r5-color-danger-500);
      }

      .wrapper.invalid:focus-within {
        box-shadow: 0 0 0 var(--r5-focus-ring-width) var(--r5-color-danger-100);
      }

      .wrapper.disabled {
        background-color: var(--r5-bg-muted);
        opacity: 0.5;
        cursor: not-allowed;
      }

      /* Sizes */
      .sm {
        min-height: var(--r5-input-height-sm);
        padding: 0 var(--r5-space-2);
        font-size: var(--r5-text-xs);
      }

      .md {
        min-height: var(--r5-input-height-md);
        padding: 0 var(--r5-space-3);
        font-size: var(--r5-text-sm);
      }

      .lg {
        min-height: var(--r5-input-height-lg);
        padding: 0 var(--r5-space-4);
        font-size: var(--r5-text-base);
      }

      input {
        flex: 1;
        min-width: 0;
        border: none;
        background: transparent;
        color: var(--r5-text);
        font-family: inherit;
        font-size: inherit;
        outline: none;
        cursor: inherit;
      }

      input::placeholder {
        color: var(--r5-text-muted);
      }

      input:disabled {
        cursor: not-allowed;
      }

      .prefix,
      .suffix {
        display: flex;
        align-items: center;
        color: var(--r5-text-muted);
      }

      .clear-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: var(--r5-space-1);
        border: none;
        background: transparent;
        color: var(--r5-text-muted);
        cursor: pointer;
        border-radius: var(--r5-radius-sm);
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      .clear-btn:hover {
        color: var(--r5-text);
        background-color: var(--r5-bg-muted);
      }

      .clear-btn svg {
        width: 0.875rem;
        height: 0.875rem;
      }

      .icon {
        display: flex;
        align-items: center;
        color: var(--r5-text-muted);
        transition: transform var(--r5-duration-fast) var(--r5-ease-default);
      }

      .icon.open {
        transform: rotate(180deg);
      }

      .icon svg {
        width: 1rem;
        height: 1rem;
      }

      /* Listbox */
      .listbox {
        position: absolute;
        top: calc(100% + var(--r5-space-1));
        left: 0;
        right: 0;
        z-index: var(--r5-z-dropdown);
        max-height: 15rem;
        overflow-y: auto;
        background-color: var(--r5-surface);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-md);
        box-shadow: var(--r5-shadow-popover, var(--r5-shadow-lg));
        opacity: 0;
        visibility: hidden;
        transform: translateY(-4px);
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      .listbox.open {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
      }

      .option {
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
        padding: var(--r5-space-2) var(--r5-space-3);
        cursor: pointer;
        transition: background-color var(--r5-duration-fast) var(--r5-ease-default);
      }

      .option:hover,
      .option.highlighted {
        background-color: var(--r5-bg-muted);
      }

      .option.selected {
        background-color: var(--r5-color-primary-50);
        color: var(--r5-color-primary-700);
      }

      .option.disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      .option-label {
        flex: 1;
      }

      .option-check {
        width: 1rem;
        height: 1rem;
        color: var(--r5-color-primary-600);
      }

      .no-results {
        padding: var(--r5-space-3);
        text-align: center;
        color: var(--r5-text-muted);
        font-size: var(--r5-text-sm);
      }

      .loading {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: var(--r5-space-3);
      }

      @media (prefers-reduced-motion: reduce) {
        .listbox,
        .icon {
          transition: none;
        }
      }
    `
];
i([
  w("input")
], t.prototype, "inputElement", 2);
i([
  s({ type: String })
], t.prototype, "value", 2);
i([
  s({ type: Array })
], t.prototype, "options", 2);
i([
  s({ type: String })
], t.prototype, "placeholder", 2);
i([
  s({ type: String, reflect: !0 })
], t.prototype, "size", 2);
i([
  s({ type: Boolean, reflect: !0 })
], t.prototype, "disabled", 2);
i([
  s({ type: Boolean, reflect: !0 })
], t.prototype, "required", 2);
i([
  s({ type: Boolean, reflect: !0 })
], t.prototype, "invalid", 2);
i([
  s({ type: String })
], t.prototype, "name", 2);
i([
  s({ type: Boolean, attribute: "clearable" })
], t.prototype, "clearable", 2);
i([
  s({ type: Boolean })
], t.prototype, "loading", 2);
i([
  s({ type: String, attribute: "no-results-text" })
], t.prototype, "noResultsText", 2);
i([
  s({ type: Boolean, attribute: "filter-options" })
], t.prototype, "filterOptions", 2);
i([
  v()
], t.prototype, "isOpen", 2);
i([
  v()
], t.prototype, "inputValue", 2);
i([
  v()
], t.prototype, "highlightedIndex", 2);
i([
  v()
], t.prototype, "hasFocus", 2);
t = i([
  k("ark-autocomplete")
], t);
export {
  t as A
};
//# sourceMappingURL=ark-autocomplete-D_vpn5d1.js.map
